// "Add sample to basket" button from the quick_addon block on the product page.
// Same add-to-cart flow as product-form.js, so the drawer refreshes and opens.
document.addEventListener('click', (event) => {
  const button = event.target.closest('.quick-addon__btn');
  if (!button) return;

  const variantId = Number(button.dataset.variantId);
  if (!variantId) return;

  const cart = document.querySelector('cart-drawer');
  const body = { id: variantId, quantity: 1 };

  if (cart) {
    body.sections = cart.getSectionsToRender().map((section) => section.id);
    body.sections_url = window.location.pathname;
    cart.setActiveElement(button);
  }

  button.disabled = true;

  fetch(`${routes.cart_add_url}.js`, { ...fetchConfig(), body: JSON.stringify(body) })
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'quick-addon',
          productVariantId: variantId,
          errors: response.errors || response.description,
          message: response.message,
        });
        return;
      }

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'quick-addon',
        productVariantId: variantId,
        cartData: response,
      });

      if (cart) {
        cart.classList.remove('is-empty');
        cart.renderContents(response);
      } else {
        window.location = window.routes.cart_url;
      }
    })
    .catch((error) => console.error(error))
    .finally(() => {
      button.disabled = false;
    });
});
